import { useContext, useEffect } from "react";
import { Box, CircularProgress, Container } from "@mui/material";
import { AssessmentContext } from "../../contexts/assessments";
import Assessments from "../../components/Assessments";
import { GroupContext } from "../../contexts/group";

const MyAssessments = () => {
  const { isLoading, refetchAssessments } = useContext(AssessmentContext);
  const { setLevel, setCurrentGroup } = useContext(GroupContext);

  useEffect(() => {
    refetchAssessments();
    setLevel(0);
    setCurrentGroup();
    localStorage.removeItem("groupLL");
  }, []);

  return (
    <Container
      maxWidth="false"
      sx={{ padding: "0px !important", backgroundColor: "#fff" }}
    >
      {isLoading && (
        <Box sx={{ padding: "48px" }}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && <Assessments />}
    </Container>
  );
};

export default MyAssessments;
